import React from "react";
import { withRouter } from "react-router-dom";

class GoToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname &&
      !new URLSearchParams(this.props.location.search).get("action")
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(GoToTop);
